import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';
import extractText from 'flarum/common/utils/extractText';
import FormError from '../form/FormError';
import PollFormState from '../../states/PollFormState';
import PollControls from '../../utils/PollControls';
import UploadPollImageButton from '../UploadPollImageButton';
import Tooltip from 'flarum/common/components/Tooltip';
import SchedulePollModal from '../SchedulePollModal';
export default class PollForm extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "options", []);
    _defineProperty(this, "optionAnswers", []);
    _defineProperty(this, "optionImageUrls", []);
    _defineProperty(this, "question", void 0);
    _defineProperty(this, "subtitle", void 0);
    _defineProperty(this, "image", void 0);
    _defineProperty(this, "imageAlt", void 0);
    _defineProperty(this, "endDate", void 0);
    _defineProperty(this, "publicPoll", void 0);
    _defineProperty(this, "allowMultipleVotes", void 0);
    _defineProperty(this, "hideVotes", void 0);
    _defineProperty(this, "allowChangeVote", void 0);
    _defineProperty(this, "maxVotes", void 0);
    _defineProperty(this, "datepickerMinDate", '');
    _defineProperty(this, "pendingAction", null);
    // Snapshot of the form payload at load (and after each successful save).
    // `state.dirty` is recomputed on every render by comparing this against
    // the live serialized form — avoids hooking every `bidi` input.
    _defineProperty(this, "snapshot", '');
    // Browser-level guard: prompts on tab close / refresh / typed-URL when
    // the form is dirty.
    _defineProperty(this, "beforeUnloadHandler", e => {
      var _this$state;
      if ((_this$state = this.state) != null && _this$state.dirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    });
  }
  oninit(vnode) {
    var _poll$tempOptions;
    super.oninit(vnode);
    this.state = new PollFormState(this.attrs.poll);

    // state handles poll initialization
    const poll = this.state.poll;
    this.options = (_poll$tempOptions = poll.tempOptions) != null ? _poll$tempOptions : poll.options();
    this.optionAnswers = this.options.map(o => Stream(o.answer()));
    this.optionImageUrls = this.options.map(o => Stream(o.imageUrl()));
    this.question = Stream(poll.question());
    this.subtitle = Stream(poll.subtitle());
    this.image = Stream(poll.image());
    this.imageAlt = Stream(poll.imageAlt());
    this.endDate = Stream(this.formatDate(poll.endDate()));
    this.publicPoll = Stream(poll.publicPoll());
    this.allowMultipleVotes = Stream(poll.allowMultipleVotes());
    this.hideVotes = Stream(poll.hideVotes());
    this.allowChangeVote = Stream(poll.allowChangeVote());
    this.maxVotes = Stream(poll.maxVotes() || 0);

    // Set minimum date for datepicker to current date
    this.datepickerMinDate = this.formatDate();

    // Replace minimum of 'today' for poll end date only if the poll is not already closed
    if (this.endDate() && dayjs(poll.endDate()).isAfter(dayjs())) {
      // We know that endDate is set, so we can safely cast the result to string
      this.datepickerMinDate = this.formatDate(poll.endDate());
    }
    this.snapshot = this.serializeFormState();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  }
  onremove(vnode) {
    super.onremove(vnode);
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  }

  /**
   * Stable JSON of every user-editable field, used to detect dirty state by
   * comparison against `this.snapshot`. Order matters — keep it stable.
   */
  serializeFormState() {
    return JSON.stringify({
      question: this.question(),
      subtitle: this.subtitle(),
      image: this.image(),
      imageAlt: this.imageAlt(),
      endDate: this.endDate(),
      publicPoll: this.publicPoll(),
      allowMultipleVotes: this.allowMultipleVotes(),
      hideVotes: this.hideVotes(),
      allowChangeVote: this.allowChangeVote(),
      maxVotes: this.maxVotes(),
      answers: this.optionAnswers.map(s => s()),
      images: this.optionImageUrls.map(s => s())
    });
  }
  refreshDirty() {
    this.state.markDirty(this.serializeFormState() !== this.snapshot);
  }
  view() {
    // Recompute dirty before each render so disabled state stays accurate
    // without wrapping every `bidi` input in an oninput hook.
    this.refreshDirty();
    return m("form", {
      onsubmit: this.onsubmit.bind(this)
    }, m("div", {
      className: "PollDiscussionModal-form"
    }, this.fields().toArray()));
  }
  fields() {
    var _this$state$poll;
    const items = new ItemList();
    items.add('question', m("div", {
      className: "Form-group Form-group--input"
    }, m("label", {
      className: "label"
    }, app.translator.trans('fof-polls.forum.modal.question_placeholder')), m("input", {
      type: "text",
      name: "question",
      className: "FormControl",
      bidi: this.question
    })), 100);
    items.add('subtitle', m("div", {
      className: "Form-group Form-group--input"
    }, m("label", {
      className: "label"
    }, app.translator.trans('fof-polls.forum.modal.subtitle_placeholder')), m("input", {
      type: "text",
      name: "subtitle",
      className: "FormControl",
      bidi: this.subtitle
    })), 95);
    const hasImage = this.image();
    items.add('poll_image', m("div", {
      className: "Form-group Form-group--upload"
    }, m("label", {
      className: "label"
    }, app.translator.trans('fof-polls.forum.modal.poll_image.label')), this.uploadConditional(hasImage, (_this$state$poll = this.state.poll) == null ? void 0 : _this$state$poll.isImageUpload(), m('[', null, m("p", {
      className: "helpText"
    }, app.translator.trans('fof-polls.forum.modal.poll_image.help')), m("input", {
      type: "hidden",
      name: "pollImage",
      bidi: this.image
    })), m(UploadPollImageButton, {
      name: "pollImage",
      poll: this.state.poll,
      onUpload: this.pollImageUploadSuccess.bind(this)
    }))), 90);
    if (hasImage) {
      items.add('poll_image_alt', m("div", {
        className: "Form-group Form-group--input"
      }, m("label", {
        className: "label"
      }, app.translator.trans('fof-polls.forum.modal.poll_image.alt_label')), m("input", {
        type: "text",
        required: true,
        name: "imageAlt",
        className: "FormControl",
        bidi: this.imageAlt
      }), m("p", {
        className: "helpText"
      }, app.translator.trans('fof-polls.forum.modal.poll_image.alt_help_text'))), 90);
    }
    items.add('answers', m("div", {
      className: "PollModal--answers Form-group Form-group--input"
    }, this.displayOptions().toArray(), m(Tooltip, {
      text: app.translator.trans('fof-polls.forum.modal.tooltip.options.add-button')
    }, m(Button, {
      className: "Button PollModal--button Button--icon PollModal--add-button",
      icon: "fas fa-plus",
      onclick: this.addOption.bind(this),
      "aria-label": extractText(app.translator.trans('fof-polls.forum.modal.tooltip.options.add-button'))
    }))), 80);
    items.add('date', m("div", {
      className: "Form-group Form-group--input"
    }, m("label", {
      className: "label"
    }, app.translator.trans('fof-polls.forum.modal.date_placeholder')), m("div", {
      className: "PollModal--date"
    }, m("input", {
      className: "FormControl",
      type: "datetime-local",
      name: "date",
      bidi: this.endDate,
      min: this.datepickerMinDate,
      max: this.formatDate('2038')
    }), Button.component({
      className: 'Button PollModal--button Button--icon',
      icon: 'fas fa-times',
      'aria-label': extractText(app.translator.trans('fof-polls.forum.modal.date_clear')),
      onclick: this.endDate.bind(this, null)
    })), this.endDate() && m("p", {
      className: "helpText"
    }, m("i", {
      class: "icon fas fa-clock"
    }), "\xA0", dayjs(this.endDate()).isBefore(dayjs()) ? app.translator.trans('fof-polls.forum.poll_ended') : app.translator.trans('fof-polls.forum.days_remaining', {
      time: dayjs(this.endDate()).fromNow()
    }))), 40);
    items.add('public', m("div", {
      className: "Form-group Form-group--switch"
    }, Switch.component({
      state: this.publicPoll() || false,
      onchange: this.publicPoll
    }, app.translator.trans('fof-polls.forum.modal.public_poll_label'))), 20);
    items.add('hide-votes', m("div", {
      className: "Form-group Form-group--switch"
    }, m(Switch, {
      state: this.endDate() && this.hideVotes(),
      onchange: this.hideVotes,
      disabled: !this.endDate()
    }, app.translator.trans('fof-polls.forum.modal.hide_votes_label')), m("p", {
      className: "helpText"
    }, app.translator.trans('fof-polls.forum.modal.hide_votes_label_help'))), 20);
    items.add('allow-change-vote', m("div", {
      className: "Form-group Form-group--switch"
    }, m(Switch, {
      state: this.allowChangeVote(),
      onchange: this.allowChangeVote
    }, app.translator.trans('fof-polls.forum.modal.allow_change_vote_label'))), 20);
    items.add('allow-multiple-votes', m("div", {
      className: "Form-group Form-group--switch"
    }, Switch.component({
      state: this.allowMultipleVotes() || false,
      onchange: this.allowMultipleVotes
    }, app.translator.trans('fof-polls.forum.modal.allow_multiple_votes_label'))), 15);
    if (this.allowMultipleVotes()) {
      items.add('max-votes', m("div", {
        className: "Form-group"
      }, m("label", {
        className: "label"
      }, app.translator.trans('fof-polls.forum.modal.max_votes_label')), m("input", {
        type: "number",
        min: "0",
        max: this.options.length,
        name: "maxVotes",
        className: "FormControl",
        bidi: this.maxVotes
      }), m("p", {
        className: "helpText"
      }, app.translator.trans('fof-polls.forum.modal.max_votes_help'))), 15);
    }
    items.add('submit-cluster', m("div", {
      className: "PollModal--submitCluster PollForm-group"
    }, this.submitItems().toArray(), this.state.poll.exists && m(Button, {
      className: "Button Button--secondary PollModal-DeleteButton",
      icon: "fas fa-trash-alt",
      loading: this.state.deleting,
      onclick: this.delete.bind(this)
    }, app.translator.trans('fof-polls.forum.modal.delete'))), -10);
    return items;
  }
  submitItems() {
    const items = new ItemList();
    const poll = this.state.poll;
    const state = this.state;

    // Drafts are global-only. For existing polls we can trust `isGlobal()`;
    // for new polls the caller's `allowDrafts` flag is the source of truth
    // since the poll hasn't been attached to anything yet.
    const draftsAvailable = this.attrs.allowDrafts === true && (!poll.exists || poll.isGlobal());
    const isNew = state.isNew();
    const isDraft = state.isDraft();
    const dirty = state.dirty;
    if (draftsAvailable && (isNew || isDraft)) {
      // Publish first so the primary action sits leftmost in the cluster.
      items.add('publish', this.publishSplitButton(), 30);

      // Distinct keys preserve the public ItemList API: third-party
      // extensions can target either button by its original key.
      items.add(isDraft ? 'update-draft' : 'save-as-draft', m(Button, {
        type: "button",
        className: "Button PollModal-SaveDraftButton",
        icon: "fas fa-save",
        loading: state.loading && this.pendingAction === 'draft',
        disabled: state.loading && this.pendingAction !== 'draft' || isDraft && !dirty,
        onclick: () => this.onSaveDraft()
      }, app.translator.trans(isDraft ? 'fof-polls.forum.compose.update_draft' : 'fof-polls.forum.compose.save_as_draft')), 20);
    } else {
      items.add('save', m(Button, {
        type: "button",
        className: "Button Button--primary PollModal-SubmitButton",
        icon: "fas fa-save",
        loading: state.loading,
        disabled: !dirty,
        onclick: () => this.onSaveChanges()
      }, app.translator.trans('fof-polls.forum.modal.submit')), 20);
    }
    return items;
  }
  publishSplitButton() {
    return m("div", {
      className: "ButtonGroup PollForm-publishCluster"
    }, m(Button, {
      className: "Button Button--primary PollModal-PublishButton",
      icon: "fas fa-paper-plane",
      loading: this.state.loading && this.pendingAction === 'publish',
      disabled: this.state.loading && this.pendingAction !== 'publish',
      onclick: () => this.publish()
    }, app.translator.trans('fof-polls.forum.compose.publish')), m(Button, {
      className: "Button Button--icon Button--primary PollModal-ScheduleButton",
      icon: "fas fa-clock",
      onclick: () => {
        // Pre-validate so we never open the schedule modal over an
        // invalid form. Without this, the modal would persist a draft
        // (failing silently), then schedule against stale DB state.
        try {
          this.data();
        } catch (error) {
          if (error instanceof FormError) {
            app.alerts.show({
              type: 'error'
            }, error.message);
            return;
          }
          throw error;
        }
        app.modal.show(SchedulePollModal, {
          poll: this.state.poll,
          form: this,
          onSuccess: () => m.route.set(app.route('fof.polls.list'))
        });
      },
      title: extractText(app.translator.trans('fof-polls.forum.compose.schedule'))
    }));
  }
  displayOptions() {
    const items = new ItemList();
    const canUpload = app.forum.attribute('canUploadPollImages');
    this.options.forEach((option, i) => {
      const imgFunc = this.optionImageUrls[i];
      items.add('option-' + i, m("div", {
        className: "Form-group Form-group--answer"
      }, m("fieldset", {
        className: "Poll-answer-input"
      }, m("label", {
        className: "FieldSet-label PollModal--answers-title"
      }, app.translator.trans('fof-polls.forum.modal.options_label') + ' ' + (i + 1)), m("input", {
        className: "FormControl",
        type: "text",
        name: 'answer' + (i + 1),
        bidi: this.optionAnswers[i]
      }), m("div", {
        className: "Poll-answer-image"
      }, this.uploadConditional(!!imgFunc(), option == null ? void 0 : option.isImageUpload(), m("div", {
        className: "Poll-answer-imageInfo"
      }, m("label", {
        className: "label"
      }, app.translator.trans('fof-polls.forum.modal.poll_option_image.label')), m("p", {
        className: "helpText"
      }, app.translator.trans('fof-polls.forum.modal.poll_option_image.help')), m("input", {
        type: "hidden",
        name: 'answerImage' + (i + 1),
        value: imgFunc()
      })), m(UploadPollImageButton, {
        name: "pollOptionImage",
        option: option,
        onUpload: this.pollOptionImageUploadSuccess.bind(this, i)
      })))), i >= 2 ? Button.component({
        type: 'button',
        className: 'Button PollModal--button Button--icon',
        icon: 'fas fa-minus',
        'aria-label': extractText(app.translator.trans('fof-polls.forum.modal.tooltip.options.remove-button')),
        onclick: i >= 2 ? this.removeOption.bind(this, i) : ''
      }) : ''));
    });
    return items;
  }
  addOption() {
    const max = Math.max(app.forum.attribute('pollMaxOptions'), 2);
    if (this.options.length < max) {
      this.options.push(app.store.createRecord('poll_options'));
      this.optionAnswers.push(Stream(''));
      this.optionImageUrls.push(Stream(''));
    } else {
      alert(extractText(app.translator.trans('fof-polls.forum.modal.max', {
        max
      })));
    }
  }
  removeOption(i) {
    this.options.splice(i, 1);
    this.optionAnswers.splice(i, 1);
    this.optionImageUrls.splice(i, 1);
  }
  data() {
    var _this$dateToTimestamp;
    if (this.question() === '') {
      throw new FormError(app.translator.trans('fof-polls.forum.modal.include_question'));
    }

    // Count options with a non-empty answer. Checking `this.options.length`
    // would be misleading — the UI keeps at least two rows on screen at all
    // times (removeOption only allows `i >= 2`), so a row count of 2 doesn't
    // imply two answers have been typed.
    const filledCount = this.optionAnswers.filter(s => {
      const v = s();
      return v != null && v.trim() !== '';
    }).length;
    if (filledCount < 2) {
      throw new FormError(app.translator.trans('fof-polls.forum.modal.min'));
    }

    // Above 2 filled, any remaining blank rows are still a problem — they'd
    // trip the server's per-row `answer: required` rule. Tell the user how
    // many empties there are so they can fill or remove them.
    const emptyCount = this.optionAnswers.length - filledCount;
    if (emptyCount > 0) {
      // extractText flattens the translator's rich-array output — FormError
      // stringifies via `+ ''`, which would otherwise join array chunks with
      // commas (e.g. "1, answer is empty…").
      throw new FormError(extractText(app.translator.trans('fof-polls.forum.modal.empty_answers', {
        count: emptyCount
      })));
    }
    const pollExists = this.state.poll.exists;
    const options = this.options.map((option, i) => {
      option.pushAttributes({
        answer: this.optionAnswers[i](),
        imageUrl: this.optionImageUrls[i]()
      });
      return pollExists ? option.data : option.data.attributes;
    });
    return {
      question: this.question(),
      subtitle: this.subtitle(),
      pollImage: this.image(),
      imageAlt: this.imageAlt(),
      endDate: (_this$dateToTimestamp = this.dateToTimestamp(this.endDate())) != null ? _this$dateToTimestamp : false,
      publicPoll: this.publicPoll(),
      hideVotes: this.hideVotes(),
      allowChangeVote: this.allowChangeVote(),
      allowMultipleVotes: this.allowMultipleVotes(),
      maxVotes: this.maxVotes(),
      options
    };
  }
  async onsubmit(event) {
    event.preventDefault();
    // Buttons are all type="button"; this only fires on Enter inside an
    // input. Route to the action that matches the cluster's current shape.
    if (this.attrs.allowDrafts === true && (this.state.isNew() || this.state.isDraft())) {
      return this.onSaveDraft();
    }
    return this.onSaveChanges();
  }
  async onSaveChanges() {
    if (await this.submit({})) {
      const alertId = app.alerts.show({
        type: 'success'
      }, app.translator.trans('fof-polls.forum.compose.success'));
      setTimeout(() => app.alerts.dismiss(alertId), 10000);
    }
  }
  async onSaveDraft() {
    this.pendingAction = 'draft';
    const wasNew = this.state.isNew();
    try {
      if (await this.submit({
        isDraft: true
      })) {
        const alertId = app.alerts.show({
          type: 'success'
        }, app.translator.trans('fof-polls.forum.compose.draft_saved'));
        setTimeout(() => app.alerts.dismiss(alertId), 10000);
        if (wasNew) {
          window.history.replaceState({}, '', app.route('fof.polls.composer', {
            id: this.state.poll.id()
          }));
        }
      }
    } finally {
      this.pendingAction = null;
      m.redraw();
    }
  }
  async publish() {
    this.pendingAction = 'publish';
    try {
      // New polls only: create as a draft first so /publish below succeeds.
      // Submitting without isDraft would publish immediately, and the
      // follow-up /publish call would 403 — the policy only permits
      // publishing drafts.
      if (!(await this.submit({
        isDraft: true
      }))) return;
      // Defensive: submit() hands off to attrs.onsubmit, which must
      // assign the saved Poll to state.poll so id() is populated for
      // /publish. Fail loudly here if a future onsubmit forgets that
      // — better than POSTing to /polls/undefined/publish.
      if (!this.state.poll.id()) {
        throw new Error('Cannot publish an unsaved poll.');
      }
      await this.state.poll.publish();
      const alertId = app.alerts.show({
        type: 'success'
      }, app.translator.trans('fof-polls.forum.poll_controls.publish_success'));
      setTimeout(() => app.alerts.dismiss(alertId), 10000);
      m.route.set(app.route('fof.polls.list'));
    } catch (error) {
      this.handleError(error);
    } finally {
      this.pendingAction = null;
      m.redraw();
    }
  }
  async submit(extra) {
    try {
      await this.attrs.onsubmit(_objectSpread(_objectSpread({}, this.data()), extra), this.state);
      // Successful save: re-baseline so the form is no longer dirty
      // until the user edits again.
      this.snapshot = this.serializeFormState();
      this.state.markDirty(false);
      return true;
    } catch (error) {
      this.handleError(error);
      return false;
    }
  }
  handleError(error) {
    if (error instanceof FormError) {
      app.alerts.show({
        type: 'error'
      }, error.message);
      return;
    }
    console.error(error);
    app.alerts.show({
      type: 'error'
    }, app.translator.trans('fof-polls.forum.modal.error'));
  }
  async delete() {
    this.state.loading = true;
    try {
      await PollControls.deleteAction(this.state.poll);
      this.state.deleting = true;
    } finally {
      this.state.loading = false;
      m.redraw();
    }
  }
  formatDate(date, def) {
    if (date === void 0) {
      date = undefined;
    }
    if (def === void 0) {
      def = false;
    }
    const dayjsDate = dayjs(date);
    if (date === false || !dayjsDate.isValid()) return def !== false ? this.formatDate(def) : false;
    return dayjsDate.format('YYYY-MM-DDTHH:mm');
  }
  dateToTimestamp(date) {
    const dayjsDate = dayjs(date);
    if (!date || !dayjsDate.isValid()) return null;
    return dayjsDate.format();
  }
  pollImageUploadSuccess(fileName) {
    var _this$state$poll2;
    this.image(fileName);
    (_this$state$poll2 = this.state.poll) == null || _this$state$poll2.pushAttributes({
      isImageUpload: !!fileName
    });
  }
  pollOptionImageUploadSuccess(index, fileName) {
    var _this$options$index;
    this.optionImageUrls[index] = Stream(fileName);
    (_this$options$index = this.options[index]) == null || _this$options$index.pushAttributes({
      isImageUpload: !!fileName
    });
  }
  uploadConditional(hasImage, isUpload, ifCanUpload, uploadButton) {
    const isExistingUrlImage = hasImage && !isUpload;

    // Existing poll with an external URL image — show deprecation notice
    if (isExistingUrlImage) {
      return m('[', null, ifCanUpload, m("p", {
        className: "helpText"
      }, app.translator.trans('fof-polls.forum.modal.poll_image.url_deprecated')), uploadButton);
    }
    return m('[', null, ifCanUpload, uploadButton);
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollForm', PollForm);